import { isProduction } from '@zapier/common-utils';

export type Alert = {
  /** A developer-friendly description of the performance problem */
  message: string;
  /** A stack trace for the origin of the performance problem */
  stack: string;
};

export type HandleAlert = (alert: Alert) => void;

type Severity = 'suppress' | 'warning' | 'error' | 'fatal';

const level = {
  get severity() {
    try {
      const localStorageVerboseFlag = localStorage.getItem('Z_PERF_SEVERITY');
      const severity = (process.env.Z_PERF_SEVERITY ||
        localStorageVerboseFlag) as Severity | null | undefined;
      return severity;
    } catch (e) {
      console.warn('Unable to read perf-utils severity level configuration');
      return 'suppress';
    }
  },
};

type UnregisterHandler = () => void;

// Default alert handler
const defaultHandler = (theAlert: Alert) => {
  const cleanedMessage =
    theAlert &&
    theAlert.message
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length)
      .join('\n');
  console.error(`🚨${cleanedMessage}`, theAlert && theAlert.stack);
};

let theHandler: HandleAlert | null = null;

// Decouple reporting from presentation
export default {
  //This is side-effecting. I'm sorry.
  alert(theAlert: Alert) {
    if (isProduction() || level.severity !== 'fatal') {
      return;
    }

    setTimeout(() => {
      defaultHandler(theAlert);

      if (theHandler) {
        theHandler(theAlert);
      }
    }, 0);
  },

  registerHandler(handler: HandleAlert): UnregisterHandler {
    theHandler = handler;

    return () => {
      theHandler = null;
    };
  },

  unregisterHandler(handler: HandleAlert) {
    if (theHandler === handler) {
      theHandler = null;
    }
  },
};
